import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SVGComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 24}
        height={props.height || 24}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <Path
            d="M10 7L15 12L10 17"
            stroke={props.color || designSystem.colors.neutral300}
            strokeWidth={1.75}
            strokeLinejoin="round"
        />
    </Svg>
);
export default SVGComponent;
